import gsap from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import L from 'leaflet';
import JapanJSON from '../../../assets/js/jp.json';
import Modal from 'bootstrap/js/dist/modal';

let modalMapDetail = new Modal(document.getElementById('MapDetailModal'), {
    keyboard: false
})

gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);

function mapInit(){
    // add max bounds
    let northEast = L.latLng(45.243953, 148.447266), //timur laut 
    southWest = L.latLng(29.53523, 126.079102),  //barat daya 
    
    bounds = L.latLngBounds(southWest, northEast);

    let zoom, minZoom;
    if (window.innerWidth > 1600) {
        zoom = 6;
        minZoom = 5;
    }
    else if (window.innerWidth > 1024) {
        zoom = 5
        minZoom = 5;
    }
    else {
        zoom = 5;
        minZoom = 3;
    }

    // init
    const map = L.map('map', {
        center: [39.876019, 136.054688],
        zoom: zoom,
        minZoom: minZoom,
        maxZoom: 10,
        zoomControl: false,
        scrollWheelZoom: false,
        maxBounds: bounds,
    });

    // map zoom control
    L.control.zoom({
        position: 'bottomleft',
    }).addTo(map);

    // map background
    L.tileLayer('').addTo(map);

    // map style
    const style = {
        "color": "#DFDFDF",
        "weight": "2",
        "fillColor": "#F5F5F5",
        "fillOpacity": '1'
    };
    const japanJSON = L.geoJSON(JapanJSON, {
        style: style,
    }).addTo(map);

    let popupGroup = L.layerGroup();
    popupGroup.addTo(map);

    // map pin

    const productionSiteData = JSON.parse(productionSite.data)

    const mappedData = productionSiteData.map(item => ({
        slug: item.slug || "",
        label: item.title || "",
        thumbnail_url: item.thumbnail_url || "",
        latLng: [parseFloat(item.lat), parseFloat(item.lang)], // adjust keys if your JSON uses different names
        show: item.show_on_map ?? true, // default true if undefined
        direction: item.marker_direction || "left-to-right",
        marker_width: getMarkerWidth(parseFloat(item.marker_width)) || 200
    }));
    const markerOptions = { data: mappedData };

    markerOptions.data.forEach((marker) => {
        if(marker.show===true){
            const customIcon = L.divIcon({
                className: 'map-marker',
                html: `<div class="map-marker__container ${marker.direction} ${marker.slug}" data-width="${marker.marker_width}">
                <div class="map-marker__icon-container open-modal" data-slug="${marker.slug}" data-image="${marker.thumbnail_url}" data-title="${marker.label}">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.13 15.87 2 12 2ZM12 11.5C11.337 11.5 10.7011 11.2366 10.2322 10.7678C9.76339 10.2989 9.5 9.66304 9.5 9C9.5 8.33696 9.76339 7.70107 10.2322 7.23223C10.7011 6.76339 11.337 6.5 12 6.5C12.663 6.5 13.2989 6.76339 13.7678 7.23223C14.2366 7.70107 14.5 8.33696 14.5 9C14.5 9.66304 14.2366 10.2989 13.7678 10.7678C13.2989 11.2366 12.663 11.5 12 11.5Z" fill="black"/>
                    </svg>
                </div>
                <div class="card-production-site-mini ${marker.slug}" data-target="${marker.slug}">
                    <h3 class="card-production-site-mini__title">${marker.label}</h3>
                    <div class="card-production-site-mini__image-container">
                        <img data-src="${marker.thumbnail_url}" src="${marker.thumbnail_url}" alt="${marker.label}" class="card-production-site-mini__image ratio-item lazyloaded" loading="lazy">
                    </div>
                </div>
                </div>`
            });
            L.marker(marker.latLng, { icon: customIcon }).addTo(map);
        }else{
            const customIcon = L.divIcon({
                className: 'map-marker bullet-marker',
                html: `<div class="map-marker__container ${marker.direction} ${marker.slug}">
                <div class="map-marker__icon-container" data-slug="${marker.slug}" data-image="${marker.thumbnail_url}" data-title="${marker.label}">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.13 15.87 2 12 2ZM12 11.5C11.337 11.5 10.7011 11.2366 10.2322 10.7678C9.76339 10.2989 9.5 9.66304 9.5 9C9.5 8.33696 9.76339 7.70107 10.2322 7.23223C10.7011 6.76339 11.337 6.5 12 6.5C12.663 6.5 13.2989 6.76339 13.7678 7.23223C14.2366 7.70107 14.5 8.33696 14.5 9C14.5 9.66304 14.2366 10.2989 13.7678 10.7678C13.2989 11.2366 12.663 11.5 12 11.5Z" fill="red"/>
                    </svg>
                </div>
                </div>`
            });
            L.marker(marker.latLng, { icon: customIcon }).addTo(map);
        }
    });

    const mapMarkerContainers = document.querySelectorAll(".map-marker__container");
    if (mapMarkerContainers) {
        mapMarkerContainers.forEach((mmc) => {
            const width = mmc.getAttribute("data-width");
            gsap.to(mmc, {
                duration: 1,
                width: width,
                autoAlpha: 1,
                stagger: 0.1,
                scrollTrigger: {
                    trigger: mmc,
                    start: "top-=200 60%",
                    //markers: true,
                },
            });
        });
    }
}

function getMarkerWidth(baseMarker) {
    const baseWidth = 1920;
    const ratio = window.innerWidth / baseWidth;
    return Math.round(baseMarker * ratio);
}

function navigationToDetailMap(){
    const cards = document.querySelectorAll('.card-production-site-mini');
    const customNavbar=document.querySelector('.custom-navbar');
    const breadcrumb=document.querySelector('.breadcrumb');

    const triggerDetailMapMobile=document.querySelector('.modal-map-detail__image-container');

    if(!cards || !customNavbar || !breadcrumb) {
        console.error('Trigger Elements or customNavbar or breadcrumb not found');
    }else{
        const customNavbarHeight=customNavbar.clientHeight;
        const navbarAndBreadCrumbHeight=customNavbarHeight;

        cards.forEach(function (card) {
            card.addEventListener('click', function () {
                const target = card.getAttribute('data-target');
                console.log(target);
                gsap.to(window, {
                    duration: 0.1, // smoother scroll
                    scrollTo: {
                        y: `#${target}` ,
                        offsetY: navbarAndBreadCrumbHeight
                    },
                });
            });
        });
    }

    if(triggerDetailMapMobile){
        triggerDetailMapMobile.addEventListener('click', function () {
            const targetMobileDetailMap = triggerDetailMapMobile.getAttribute('data-target');
            gsap.to(window, {
                duration: 0.1, // smoother scroll
                scrollTo: {
                    y: `#${targetMobileDetailMap}` ,
                    offsetY: 79
                },
            });

            modalMapDetail.hide();
        });
    }
    

}

function detailMapMobile() {
    const mapMarkerContainers = document.querySelectorAll(".map-marker__icon-container.open-modal");

    if (!mapMarkerContainers.length) {
        console.warn("⚠️ No map marker containers found.");
        return;
    }

    mapMarkerContainers.forEach((container, index) => {
        container.addEventListener("click", () => {
            const mapImageUrl = container.getAttribute("data-image");  // ✅ shorthand for data-image
            const mapTitle = container.getAttribute("data-title");
            const mapSlug = container.getAttribute("data-slug");
            const modalDetailMapTitleElm = document.querySelector(".modal-map-detail__title");
            const modalDetailMapImageElm = document.querySelector(".modal-map-detail__image");
            const modalDetailMapImageContainerElm = document.querySelector(".modal-map-detail__image-container");
            modalDetailMapImageContainerElm.dataset.target = mapSlug;
            modalMapDetail.show();
            modalDetailMapTitleElm.innerHTML = mapTitle;
            modalDetailMapImageElm.src = mapImageUrl;
        });
    });
}


export function initProductionSiteMap() {
    mapInit();
    if (window.innerWidth < 992) {
        detailMapMobile();
    }
    navigationToDetailMap()

    window.addEventListener('resize',function(){
        
        if (window.innerWidth < 992) {
            detailMapMobile();
        }
        navigationToDetailMap()
    })
}